import { List as ImmutableList, Map as ImmutableMap } from 'immutable';
import { getSenderId, getSenderType, getSender, getType
// @ts-ignore untyped JS module
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { AGENT, BOT } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { COMMON_MESSAGE } from 'conversations-message-history/common-message-format/constants/messageTypes';
export const RESPONDER_JOINED = 'RESPONDER_JOINED';
export const insertResponderJoinedMessages = (messages, humanAgentSenderIds = '') => {
  const humanIds = humanAgentSenderIds ? new Set(humanAgentSenderIds.split(',')) : new Set();
  let lastSenderKey = null;
  let isFirstResponder = true;
  let joinedCount = 0;
  return messages.reduce((result, msg) => {
    const messageType = getType(msg);
    const senderType = getSenderType(msg);
    if (messageType === COMMON_MESSAGE && (senderType === AGENT || senderType === BOT)) {
      const senderId = getSenderId(msg);
      const senderKey = `${senderType}:${senderId}`;
      if (senderId !== null && senderKey !== lastSenderKey) {
        lastSenderKey = senderKey;
        const isHuman = senderType === AGENT && humanIds.has(String(senderId));
        const suppressJoinedMessage = isFirstResponder && !isHuman;
        isFirstResponder = false;
        if (!suppressJoinedMessage) {
          joinedCount++;
          result = result.push(ImmutableMap({
            '@type': RESPONDER_JOINED,
            id: `responder-joined-${senderKey}-${joinedCount}`,
            sender: getSender(msg)
          }));
        }
      }
    }
    return result.push(msg);
  }, ImmutableList());
};